import { TranscriptionService } from '@klangio/ai2notes-ts-client';
import { Button } from '@mui/material';
import { useContext } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import type { TranscriptionDialogContextValue } from '../../../context/TranscriptionDialogContext/TranscriptionDialogContext';
import withTranscriptionDialogContextProvider from '../../../context/TranscriptionDialogContext/withTranscriptionDialogContextProvider';
import { TranscriptionStoreContext } from '../../../context/TranscriptionStoreContext/TranscriptionStoreContext';
import type { Transcription } from '../../../entities';
import { TrackingAction, TrackingCategory, trackingService } from '../../../services';
import TranscriptionDialog from './TranscriptionDialog/TranscriptionDialog';
import { safeJSONParse } from '../../../utils';

export interface ReTranscribeDialogProps extends TranscriptionDialogContextValue {
  open: boolean;
  onClose: (hasReTranscribed: boolean) => void;
  transcription: Transcription;
}

const ReTranscribeDialog: React.FC<ReTranscribeDialogProps> = ({
  open,
  onClose,
  transcription,
  settings,
}) => {
  const { t } = useTranslation();
  const [submitting, setSubmitting] = React.useState(false);
  const { updateTranscriptions } = useContext(TranscriptionStoreContext);

  const handleRetranscription = () => {
    setSubmitting(true);
    const retranscribeIds = window.localStorage.getItem('retranscribe')
      ? `${window.localStorage.getItem('retranscribe')},${transcription.id}`
      : transcription.id;
    window.localStorage.setItem('retranscribe', retranscribeIds);
    trackingService.valueObjectEvent<{ location: string; input: string }>(
      TrackingCategory.Transcription,
      TrackingAction.RETRANSCRIBE,
      {
        location: 'songbook',
        input: transcription.source,
      },
    );
    const params = {
      apriori: {
        title: safeJSONParse(transcription.parameters)?.apriori?.title,
        composer: safeJSONParse(transcription.parameters)?.apriori?.composer,
        agreedToTerms: safeJSONParse(transcription.parameters)?.apriori?.agreedToTerms,
      } as TranscriptionDialogContextValue['apriori'],
      settings,
    };

    TranscriptionService.transcriptionRetranscribeSheet({
      id: transcription.id,
      parameters: JSON.stringify(params),
    }).then(() => {
      setTimeout(() => {
        setSubmitting(false);
        updateTranscriptions();
        onClose(true);
      }, 1000);
    });
  };
  if (!open) return null;

  return (
    <TranscriptionDialog
      isRetranscribe
      handleClose={() => onClose(true)}
      open
      customSubmitButton={(
        <div style={{ textAlign: 'right' }}>
          <Button onClick={handleRetranscription} disabled={submitting} variant="contained">
            {t('home.songbook.retranscribe')}
          </Button>
        </div>
      )}
    />
  );
};

export default withTranscriptionDialogContextProvider(ReTranscribeDialog);
